import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {fadeAnimation} from "@shared/animations/fade.animation";
import {UrlService} from "@services/url.service";
import {environment} from "@environment";

declare var PCWidget: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeAnimation]
})
export class AppComponent implements OnInit{
    networkClass;
    favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    title: any = document.querySelector('#appTitle');

    constructor(
        public urlService: UrlService,
    ) {
    }

    ngOnInit() {
        if (!environment.debug) {
            this.loadPureChat();
        }
        this.loadFBPixelCode();
        this.networkClass = this.urlService.getNetwork();
        if (this.networkClass === 'sm') {
            this.loadGoogleTagManager();
            // this.loadHotJar();
        }
        this.changeIconAndTitle();
    }

    loadPureChat() {
        var done = false;
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript';
        document.getElementsByTagName('HEAD')
            .item(0)
            .appendChild(script);

        script.onload = (e) => {
            var w = new PCWidget({
                c: this.urlService.getNetwork() === 'sm' ? '446fcbec-643d-451f-aca4-8c3dcabb098a' : '68bd1b6c-2d97-43ab-9e26-810f61a026f7',
                f: true
            });
            done = true;
        };
    }

    loadGoogleTagManager() {
        let body = <HTMLDivElement>document.body;
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = '';
        script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-153876183-2';
        script.async = true;
        script.defer = true;
        body.appendChild(script);
        script.innerHTML = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'UA-153876183-2');";
        document.head.appendChild(script);
    }

    loadHotJar() {
        let body = <HTMLDivElement>document.body;
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = '(function(h,o,t,j,a,r){' +
            '        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};' +
            '        h._hjSettings={hjid:3364512,hjsv:6};' +
            '        a=o.getElementsByTagName(‘head’)[0];' +
            '        r=o.createElement(‘script’);r.async=1;' +
            '        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;' +
            '        a.appendChild(r);' +
            '    })(window,document,‘https://static.hotjar.com/c/hotjar-\',\'.js?sv=’);';
        body.appendChild(script);

        document.head.appendChild(script);
    }

    loadFBPixelCode() {
        // !function (f, b, e, v, n, t, s) {
        //   if (f.fbq) {
        //     return;
        //   }
        //   n = f.fbq = function () {
        //     n.callMethod ?
        //       n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        //   };
        //   if (!f._fbq) {
        //     f._fbq = n;
        //   }
        //   n.push = n;
        //   n.loaded = !0;
        //   n.version = '2.0';
        //   n.queue = [];
        //   t = b.createElement(e);
        //   t.async = !0;
        //   t.src = v;
        //   s = b.getElementsByTagName(e)[0];
        //   s.parentNode.insertBefore(t, s)
        // }(window, document, 'script',
        //   'https://connect.facebook.net/en_US/fbevents.js');
        // fbq('init', '565085247416512');
        // fbq('track', 'PageView');
        // fbq('track', 'Purchase');
    }

    changeIconAndTitle() {
        const getShopInfo = this.urlService.getShop();
        this.favIcon.href = getShopInfo.favicon;
        if (this.networkClass === 'sm') {
            this.title.text = 'SM Shop';
        } else if (this.networkClass === 'mm') {
            this.title.text = 'MM Shop';
        }
    }

}
